import React from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import { List, Spin, Typography } from "antd";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../core/hooks/useAuth";
import { useHandleNotifications } from "../../../core/hooks/useHandleNotifications";

const { Text, Paragraph } = Typography;

const Notification = () => {
  const location = useLocation();
  const { moodleUser } = useAuth();
  const { userNotifications, isUserNotificationsLoading } = useHandleNotifications(moodleUser?.id);

  const selectedItem = (location.state as { item?: any | any[] } | null)?.item;
  const apiNotifications = userNotifications?.messages?.filter(
    (notification: any) => notification.eventtype
  ) || [];
  const notifications = selectedItem
    ? (Array.isArray(selectedItem) ? selectedItem : [selectedItem])
    : apiNotifications;

  const formatTime = (timestamp: string) => {
    const date = new Date(Number(timestamp) * 1000);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) return `${diffInSeconds} giây trước`;
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} phút trước`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} giờ trước`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)} ngày trước`;
    return date.toLocaleDateString("vi-VN");
  };

  return (
    <>
      <Breadcrumb title="Thông báo" />
      <div className="content">
        <div className="container">
          <div className="notification-content">
            <div className="notification-head">
              <h2 className="fs-32 fw-bold mb-1">Thông báo</h2>
              <p className="mb-0">Danh sách đầy đủ thông báo của bạn.</p>
            </div>
            {isUserNotificationsLoading ? (
              <div className="text-center py-4">
                <Spin />
              </div>
            ) : (
              <List
                dataSource={notifications}
                locale={{ emptyText: "Không có thông báo" }}
                renderItem={(item: any) => (
                  <List.Item style={{ alignItems: "flex-start" }}>
                    <List.Item.Meta
                      title={<Text strong>{item.subject}</Text>}
                      description={
                        <div>
                          <Paragraph style={{ marginBottom: 8 }}>
                            {item.fullmessage || item.smallmessage || "Không có nội dung"}
                          </Paragraph>
                          <Text type="secondary">{formatTime(item.timecreated)}</Text>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Notification;
